<template>
  <v-row no-gutters>
    <v-col cols="12" sm="12" md="6" lg="6" align-self="center">
      <div class="d-flex justify-center">
        <div class="title">
          <p class="text-h1">{{ $t('PAGE_404_TITLE') }}</p>
          <p class="text-body-1 grey-font mb-8">{{ $t('PAGE_404_DESCRIPTION') }}</p>
          <v-btn color="primary" large tile>{{ $t('PAGE_404_BUTTON') }}</v-btn>
        </div>
      </div>
    </v-col>
    <v-col cols="12" sm="12" md="6" lg="6">
      <div class="d-flex justify-center img404 ">
        <v-img
          :class="`mt-12 ${$vuetify.breakpoint.mdAndUp ? 'background-img' : null}`"
          :src="require('@/assets/404img.svg')"
        />
      </div>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'NotFound',
  data() {
    return {}
  },
}
</script>

<style scoped lang="scss">
.title {
  width: rem(400);
}
.img404 {
  width: 65%;
}
</style>
